export default "__VITE_ASSET__B$9lvsn8__"